import axios from "axios";
import app from "./app";
import store from "./store";
import hmacSHA512 from "crypto-js/hmac-sha512";

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.status === 401) {
            localStorage.isLogin = false;
            localStorage.removeItem("nToken");
            app.$store.dispatch("auth/logout");
            window.location = "/";
            return;
        } else if (error.response.status === 444) {
            localStorage.isLogin = true;
            window.location = "/";
            return;
        } else if (419 === error.response.status) {
            store.dispatch("sound/sfx", "Error");
            app.$root.$bvModal
                .msgBoxOk(
                    error.response.data.message != undefined
                        ? error.response.data.message
                        : app.$t("validation.error_default_text"),
                    {
                        title: app.$t("validation.error_default_title"),
                        size: "sm",
                        buttonSize: "lg",
                        okTitle: app.$t("base.btn_ok"),
                        modalClass: "confirmModal",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((r) => {
                    store.dispatch("sound/sfx", "Button");
                });

            app.$router.go();
            return;
        } else if (
            error.response.status === 502 ||
            error.response.status === 503
        ) {
            store.dispatch("sound/sfx", "Error");
            app.$root.$bvModal
                .msgBoxOk(
                    error.response.data.message != undefined
                        ? error.response.data.message
                        : app.$t("validation.error_maintenance_text"),
                    {
                        title: app.$t("validation.error_maintenance_title"),
                        size: "sm",
                        buttonSize: "lg",
                        okTitle: app.$t("base.btn_ok"),
                        modalClass: "confirmModal",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((r) => {
                    store.dispatch("sound/sfx", "Button");
                });

            app.$store.dispatch("auth/logout");
            app.$router.push({ name: "login" });
            return;
        } else if (error.response.status >= 500) {
            store.dispatch("sound/sfx", "Error");
            app.$root.$bvModal
                .msgBoxOk(
                    error.response.data.message != undefined
                        ? error.response.data.message
                        : app.$t("validation.error_default_text"),
                    {
                        title: app.$t("validation.error_default_title"),
                        size: "sm",
                        buttonSize: "lg",
                        okTitle: app.$t("base.btn_ok"),
                        modalClass: "confirmModal",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((r) => {
                    store.dispatch("sound/sfx", "Button");
                });
        }

        return Promise.reject(error);
    }
);

export default {
    baseErrorHendler(error) {
        if (error.response.status >= 500) return; // already shown
        store.dispatch("sound/sfx", "Error");
        app.$root.$bvModal
            .msgBoxOk(
                error.response.data.message != undefined
                    ? error.response.data.message
                    : app.$t("validation.error_default_text"),
                {
                    title: app.$t("validation.error_default_title"),
                    size: "sm",
                    buttonSize: "lg",
                    okTitle: app.$t("base.btn_ok"),
                    modalClass: "confirmModal",
                    hideHeaderClose: false,
                    centered: true,
                }
            )
            .then((r) => {
                store.dispatch("sound/sfx", "Button");
            });
    },

    config() {
        return axios.get("/config");
    },

    referralValidation(msisdn, referralUsername) {
        return axios.post("/referrals/validation", {
            msisdn,
            referralUsername,
        });
    },

    login(data) {
        return axios.post("/login", data);
    },

    logout() {
        return axios.post("/logout");
    },

    budget() {
        return axios.get("/budget");
    },

    me() {
        return axios.get("/me");
    },

    deleteAccount() {
        return axios.delete("/me");
    },

    updateMe(params) {
        return axios.post("/me", params);
    },

    settings() {
        return axios.get("/settings");
    },

    setSettings(data) {
        return axios.post("/settings", data);
    },

    // otp

    otpSms(msisdn, token) {
        return axios.post("/oauth/otp-sms", { msisdn, token, platform: "web" });
    },

    // profile

    allInterests() {
        return axios.get(`/ad-categories`);
    },

    interests() {
        return axios.get(`/me/interests`);
    },

    activePayments(page) {
        return axios.get(`/me/payments/active`, { params: { page } });
    },

    archivedPayments(page) {
        return axios.get(`/me/payments/archived`, { params: { page } });
    },

    // avatar

    getCommonAvatars() {
        return axios.get("/avatars/common");
    },

    uploadAvatar(resp) {
        const formData = new FormData();
        formData.append("image", resp);

        return axios.post("/me/avatar", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },

    setAvatar(name) {
        return axios.post("/me/avatar", { name });
    },

    // ad quiz

    addAdQuizToBlacklist(quizId) {
        return axios.post("/ad-quiz/blacklist", { quizId });
    },

    clearAdQuizToBlacklist() {
        return axios.delete("/ad-quiz/blacklist");
    },

    adQuiz() {
        return axios.get("/ad-quiz");
    },

    adQuizProfit() {
        return axios.get("/ad-quiz/profit");
    },

    adQuizQuestion(quizId) {
        return axios.get(`/ad-quiz/${quizId}/questions/next`);
    },

    setAdQuizAnswer(quizId, questionId, answerId) {
        return axios.post(
            `/ad-quiz/${quizId}/questions/${questionId}/answers`,
            { answerId }
        );
    },

    // demo ad quiz

    adQuizDemo() {
        return axios.get("/ad-quiz/demo");
    },

    adQuizDemoQuestion() {
        return axios.get(`/ad-quiz/demo/question`);
    },

    setAdQuizDemoAnswer(answerId) {
        return axios.post(`/ad-quiz/demo/question/answer`, {
            answerId,
        });
    },

    // survey

    getAdSurveyQuestion(quizId) {
        return axios.get(`/ad-surveys/${quizId}/questions/next`);
    },

    adSurveyAnswer(questionId, answerId) {
        return axios.post(`/ad-surveys/questions/answers`, {
            questionId,
            answerId,
        });
    },

    getUserSegmentationQuestion() {
        return axios.get("/user-segmentation/questions/next");
    },

    userSegmentationAnswer(questionId, answerIds) {
        return axios.post(`/user-segmentation/questions/answers`, {
            questionId,
            answerIds,
        });
    },

    // trivia

    triviaQuiz() {
        return axios.get("/trivia-quiz");
    },

    triviaQuizApply(quizId) {
        return axios.post(`/trivia-quiz/${quizId}/apply`);
    },

    triviaQuizAnswer(quizId, questionId, answerId) {
        return axios.post(
            `/trivia-quiz/${quizId}/questions/${questionId}/answers`,
            { answerId }
        );
    },

    triviaQuizAnswerJoker(quizId, questionId) {
        return axios.post(
            `/trivia-quiz/${quizId}/questions/${questionId}/answers`,
            { joker: true }
        );
    },

    triviaQuizWinners(page) {
        return axios.get(`/trivia-quiz/winners`, { params: { page } });
    },

    triviaQuizFlow(quizId, questionId) {
        return axios.get(`/trivia-quiz/${quizId}/questions/${questionId}/flow`);
    },

    triviaQuizLatestQuestion(quizId) {
        return axios.get(`/trivia-quiz/${quizId}/questions/latest`);
    },

    // Super Challenge

    superChallenge() {
        return axios.get("/super-challenge");
    },

    superChallengeApply(id) {
        return axios.post(`/super-challenge/${id}/apply`);
    },

    superChallengeQuestionAnswer(
        challengeId,
        answerId,
        answerTime,
        confirmCode
    ) {
        return axios.post(`/super-challenge/${challengeId}/answers`, {
            answerId,
            answerTime,
            key: hmacSHA512(
                confirmCode,
                document.head.querySelector('meta[name="csrf-token"]').content
            ).toString(),
        });
    },

    superChallengeParticipants(challengeId, page) {
        return axios.get(`/super-challenge/${challengeId}/participants`, {
            params: { page },
        });
    },

    // referrals

    referralAllocations(offsetDateTime) {
        return axios.get(`/referral/allocations`, {
            params: { offsetDateTime },
        });
    },

    referralProfit(period) {
        return axios.get(`/referral/profit`, { params: { period } });
    },

    referralMy(period, page) {
        return axios.get(`/referral/my`, {
            params: { period, page },
        });
    },

    // shop

    shop() {
        return axios.get(`/shop`);
    },

    shopBuyJokers(packageId) {
        return axios.post(`/shop/jokers/${packageId}`);
    },

    shopBuyDiamonds(packageId) {
        return axios.post(`/shop/diamonds/${packageId}`);
    },

    shopBuyMtsPointPackages(packageId) {
        return axios.post(`/shop/mts-points/${packageId}`);
    },

    shopBuyCheques(data) {
        return axios.post(`/shop/cheques`, data);
    },

    updateCheques(data) {
        return axios.post(`/shop/cheques/update`, data);
    },

    shopBuyVouchers(data) {
        return axios.post(`/shop/vouchers`, data);
    },

    updateVouchers(data) {
        return axios.post(`/shop/vouchers/update`, data);
    },

    shopBuySwapperJokers(packageId) {
        return axios.post(`/shop/swappers/joker-packages/${packageId}`);
    },

    shopBuySwapperTokens(packageId) {
        return axios.post(`/shop/swappers/token-packages/${packageId}`);
    },

    // news

    news() {
        return axios.get(`/news`);
    },

    updateNotificationToken(token, platform) {
        return axios.post(`/me/notifications`, {
            token,
            platform,
        });
    },

    giveaway() {
        return axios.get(`/giveaway/active`);
    },

    // challenges

    challengeTypes() {
        return axios.get(`/challenges/types`);
    },

    challengeBudget() {
        return axios.get(`/challenges/budget/info`);
    },

    finishedChallenges() {
        return axios.get(`/challenges/finished`);
    },

    challengeInfo(challengeId) {
        return axios.get(`/challenges/${challengeId}`);
    },

    applyToChallenge(typeId) {
        return axios.post(`/challenges`, { typeId });
    },

    answerToChallengeQuestion(challengeId, answerId, answerTime) {
        return axios.post(`/challenges/${challengeId}/answers`, {
            answerId,
            answerTime,
        });
    },

    replaceChallengeQuestion(challengeId) {
        return axios.patch(`/challenges/${challengeId}/question`);
    },

    // teams

    teamsRankings(page = 1, count = 40) {
        return axios.get(`/teams/rankings`, {
            params: { count, page },
        });
    },

    teamsCreate(name) {
        return axios.post(`/teams`, { name });
    },

    teams(name, onlyUnfilled = true, page = 1, count = 40) {
        return axios.get(`/teams`, {
            params: {
                name,
                onlyUnfilled,
                count,
                page,
            },
        });
    },

    teamsCreateRequest(teamId) {
        return axios.post(`/teams/${teamId}/requests`);
    },

    teamsInvitations(page = 1, count = 40) {
        return axios.get(`/teams/invitations`, {
            params: { count, page },
        });
    },

    teamsAcceptInvitations(invitationId) {
        return axios.post(`/teams/invitations/${invitationId}/acceptance`);
    },

    teamsDenyInvitations(invitationId) {
        return axios.post(`/teams/invitations/${invitationId}/denial`);
    },

    teamMembers(page = 1, count = 100) {
        return axios.get(`/teams/members`, {
            params: { count, page },
        });
    },

    teamRequests(teamId, page = 1, count = 100) {
        return axios.get(`/teams/${teamId}/requests`, {
            params: { count, page },
        });
    },

    teamApprovalRequests(requestId) {
        return axios.post(`/teams/requests/${requestId}/approval`);
    },

    teamDenyRequests(requestId) {
        return axios.post(`/teams/requests/${requestId}/denial`);
    },

    teamLeave() {
        return axios.delete(`/teams/members/me`);
    },

    teamKickOut(memberId) {
        return axios.delete(`/teams/members`, {
            params: { memberId },
        });
    },

    teamCreateIvitation(inviteeId) {
        return axios.post(`/teams/invitations`, { inviteeId });
    },

    /* Team Chat */
    teamMessages(page = 1, count = 50) {
        return axios.get(`/teams/messages`, { params: { page, count } });
    },

    teamMessagesSend(predefinedMessageId) {
        return axios.post(`/teams/messages`, {
            predefinedMessageId: predefinedMessageId,
        });
    },

    teamMessagesPredefined() {
        return axios.get(`/teams/messages/predefined`);
    },

    seasons(page = 1, count = 20) {
        return axios.get(`/seasons`, { params: { count, page } });
    },

    gameweeks(page = 1, count = 20) {
        return axios.get(`/gameweeks`, {
            params: { count, page },
        });
    },

    competitionPeriods() {
        return axios.get(`/competition-periods`);
    },

    usersWithoutTeam(username, page = 1, count = 40) {
        return axios.get(`/users`, {
            params: {
                username,
                withoutTeam: true,
                page,
                count,
            },
        });
    },

    teamSeasonRankins(seasonId, page = 1, count = 20) {
        return axios.get(`/teams/rankings`, {
            params: { seasonId, count, page },
        });
    },

    teamGameweekRankins(gameweekId, page = 1, count = 20) {
        return axios.get(`/teams/rankings`, {
            params: { gameweekId, count, page },
        });
    },

    // auctions

    auctionsActive({
        page = 1,
        count = 20,
        includeMtsCustomerCategory = null,
    }) {
        return axios.get(`/auctions/active`, {
            params: { page, count, includeMtsCustomerCategory },
        });
    },

    auctionsWon() {
        return axios.get(`/auctions/won`);
    },

    auctionsFinished() {
        return axios.get(`/auctions/finished`);
    },

    auctionsBids(auctionId, page = 1, count = 20) {
        return axios.get(`/auctions/${auctionId}/bids`, {
            params: { page, count },
        });
    },

    auctionsBidders(auctionId, page = 1, count = 20) {
        return axios.get(`/auctions/${auctionId}/bidders`, {
            params: { page, count },
        });
    },

    auctionsQuestionnaire(auctionId) {
        return axios.get(`/auctions/${auctionId}/questionnaire`);
    },

    auctionsQuestionnaireAnswer(auctionId, answerId, answerTime) {
        return axios.post(`/auctions/${auctionId}/questionnaire/answer`, {
            answerId,
            answerTime,
        });
    },

    auctionsCreateBid(auctionId, amount) {
        return axios.post(`/auctions/${auctionId}/bids`, { amount });
    },

    auctionsInfo(auctionId) {
        return axios.get(`/auctions/${auctionId}`);
    },

    updateAuctionRequest(data) {
        return axios.post(`/auctions/payment/update`, data);
    },

    createAuctionRequest(data) {
        return axios.post(`/auctions/payment`, data);
    },

    addFavorites(auctionId) {
        return axios.post(`/auctions/${auctionId}/favourites`);
    },

    deleteFavorites(auctionId) {
        return axios.delete(`/auctions/${auctionId}/favourites`);
    },

    /* MTS loyalty */
    mtsCustomerEmails(customerId) {
        return axios.get(`/mts/customers/${customerId}/connections/emails`);
    },

    mtsCustomerCode(customerId, email) {
        return axios.post(`/mts/customers/${customerId}/connections/codes`, {
            email,
        });
    },

    mtsCustomerConfirm(customerId, code) {
        return axios.post(
            `/mts/customers/${customerId}/connections/confirmation`,
            { code }
        );
    },

    /* Family */
    familyMembers() {
        return axios.get(`/families/members`);
    },

    familyTransactions(page = 1, count = 50) {
        return axios.get(`/families/transactions`, {
            params: { count, page },
        });
    },

    familySentInvitations(page = 1, count = 50) {
        return axios.get(`/families/invitations/sent`, {
            params: { count, page },
        });
    },

    familyReceivedInvitations(page = 1, count = 50) {
        return axios.get(`/families/invitations/received`, {
            params: { count, page },
        });
    },

    usersWithoutFamily(username, page = 1, count = 40) {
        return axios.get(`/users`, {
            params: {
                username,
                withoutFamily: true,
                page,
                count,
            },
        });
    },

    familyCreateIvitation(inviteeId) {
        return axios.post(`/families/invitations`, { inviteeId });
    },

    familyCancelInvitation(invitationId) {
        return axios.delete(`/families/invitations/${invitationId}`);
    },

    familyDenyInvitations(invitationId) {
        return axios.post(`/families/invitations/${invitationId}/denial`);
    },

    familyAcceptInvitation(invitationId) {
        return axios.post(`/families/invitations/${invitationId}/acceptance`);
    },

    familyLeave() {
        return axios.delete(`/families/members/me`);
    },

    familyKickOut(memberId) {
        return axios.delete(`/families/members`, {
            params: { memberId },
        });
    },

    familyTransactionsOptions() {
        return axios.get(`/families/transactions/options`);
    },

    familyTransactionsSend(recipientId, diamonds) {
        return axios.post(`/families/transactions`, {
            recipientId,
            diamonds,
        });
    },

    // support
    supportMessages() {
        return axios.get(`/support/messages`);
    },

    supportMessagesSend(text) {
        return axios.post(`/support/messages`, { text });
    },
};
